import React from 'react';
import { FormattedMessage } from 'react-intl';

import { translations } from '@/locales';

interface Props {
  section: 'dataProcessing' | 'dataCollection' | 'disclosure' | 'storageTime' | 'rights' | 'complaints' | 'changes';
  values?;
}

export const PrivacyPolicyItem: React.FC<Props> = ({ section, values }) => {
  return (
    <React.Fragment>
      <div className="text-xl md:text-2xl font-extrabold mb-2 text-orange-light mt-10 first:mt-0">
        <FormattedMessage id={translations.pages.privacy.sections[section].title} />
      </div>

      <div className="font-medium text-purple-medium">
        <FormattedMessage
          id={translations.pages.privacy.sections[section].content}
          values={{
            br: <br />,
            ...values
          }}
        />
      </div>
    </React.Fragment>
  );
};
